import axios from 'axios';
import UtilService from '@/services/UtilService';
import TokenService from '@/services/TokenService';

const URLSearchParams = require('url-search-params');
const validateStatus = status => (status < 400);

// The "client" value is persisted in the resource, and is used when reviewing payment reports, since multiple clients
// now consume the payments API.
// If the app has been started with any testMode enabled, send the client as "Test", otherwise send as "ExpressPay"
const CLIENT_EXPRESS_PAY = 'ExpressPay';
const CLIENT_TEST_EXPRESS_PAY = 'TestExpressPay';

export default {
  createPaymentResource(policyNumber, zipCode, returnUrl, testMode) {
    const client = testMode ? CLIENT_TEST_EXPRESS_PAY : CLIENT_EXPRESS_PAY;
    return TokenService.getPolicyZipToken(policyNumber, zipCode)
      .then(bearerToken => {
        return axios({
          method: 'POST',
          url: `${process.env.MEDI_PAYMENTS}`,
          data: {
            returnUrl,
            policyNumber,
            client
          },
          headers: {
            authorization: `Bearer ${bearerToken}`
          },
          validateStatus
        });
      });
  },
  async updatePaymentResource(policyNumber, zipCode, resourceId, state, cardNumber, accountType) {
    let payload = {
      state
    };

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('hash')) {
      payload.tcMetadata = {
        paymentType: urlParams.get('cc') ? 'CC' : 'ACH',
        hash: urlParams.get('hash'),
        amount: parseFloat(urlParams.get('amount'))
      };

      if (urlParams.get('cc')) {
        payload.tcMetadata.ccMetadata = {
          type: UtilService.getCardType(cardNumber),
          lastFour: urlParams.get('cc'),
          exp: urlParams.get('exp')
        };
      } else {
        payload.tcMetadata.achMetadata = {
          type: accountType,
          lastFour: urlParams.get('routing').substr(5)
        };
      }
    }

    return TokenService.getPolicyZipToken(policyNumber, zipCode)
      .then(bearerToken => {
        return axios({
          method: 'PATCH',
          url: `${process.env.MEDI_PAYMENTS}/${resourceId}`,
          data: payload,
          headers: {
            authorization: `Bearer ${bearerToken}`
          },
          validateStatus
        });
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/PaymentService.js